<script>
    export default {
        functional: true,

        props: {
            xs: {type: String, default: null},
            sm: {type: String, default: null},
            md: {type: String, default: null},
            lg: {type: String, default: null},
            xl: {type: String, default: null},
            space: {type: [String, Number], default: 2},
        },

        render: function(createElement, context) {
            let classes = ['panel-inner'];
            let {xs, sm, md, lg, xl, space} = context.props;

            if (xs === null && sm === null && md === null && lg === null && xl === null) {
                md = 'wrap';
            }
            if (xs === null) {
                xs = 'list';
            }

            classes.push(`panel-xs-${xs}`);
            if (sm !== null) {
                classes.push(`panel-sm-${sm}`);
            }
            if (md !== null) {
                classes.push(`panel-md-${md}`);
            }
            if (lg !== null) {
                classes.push(`panel-lg-${lg}`);
            }
            if (xl !== null) {
                classes.push(`panel-xl-${xl}`);
            }

            classes.push(`panel-space-${space}`);

            return createElement('div', {class: 'panel', on: context.listeners, ...context.data}, [
                createElement('div', {class: classes}, context.children),
            ]);
        },
    };
</script>